import { IVerbaScholaLessonReviewIssue, IVerbaScholaLessonReviewIssues } from '../api/VerbaScholaApi';

export type LessonReviewPageScope = 'plan' | 'exercises';

const needsReview = (issue: IVerbaScholaLessonReviewIssue) => issue.status === 'open' || issue.status === 'changed';

/** Keep the page's review count and popup list aligned. Pictures belong to Exercises. */
export function lessonReviewForPage(review: IVerbaScholaLessonReviewIssues, page: LessonReviewPageScope): IVerbaScholaLessonReviewIssues {
    const issues = review.issues.filter(issue => page === 'plan' ? issue.source === 'plan' : issue.source !== 'plan');
    const pending = issues.filter(needsReview);
    return {
        issues,
        counts: {
            open: pending.length,
            warning: pending.filter(issue => issue.severity === 'warning').length,
            error: pending.filter(issue => issue.severity === 'error').length,
        },
    };
}
